import { nakiRadioSystemTypes } from "common/constants";
import BaseHomeSectionListViewStore from "./BaseHomeSectionListViewStore";

class NakiMobileHomeSectionListViewStore extends BaseHomeSectionListViewStore {
    constructor(rootStore, { routeStore }) {
        super(rootStore, { routeStore });
        this.mobileAppSystemType = nakiRadioSystemTypes.mobile;
    }
}

export default NakiMobileHomeSectionListViewStore;
